import React from 'react';
import { Heading } from '@uhg-abyss/web/ui/Heading';

export const Forbidden = () => {
  return (
    <React.Fragment>
      <div></div>
      <Heading
        level={1}
        color="#002677"
        style={{
          top: '50%',
          position: 'absolute',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        You do not have permissions to view this page.
      </Heading>
    </React.Fragment>
  );
};
